import { Button, Form, Input } from "antd";
import FormItem from "antd/es/form/FormItem";
import TextArea from "antd/lib/input/TextArea";
import PropTypes from "prop-types";
import { useEffect, useRef, useState } from "react";
import useToast from "../../../../hooks/userToast";
import { usePatch } from "../../../../hooks/apiHooks";
import apiClient from "../../../../utils/apiClient";

MasterEdit.propTypes = {
  id: PropTypes.number,
  name: PropTypes.string,
  description: PropTypes.string,
  fetchData: PropTypes.func.isRequired,
  handleOk: PropTypes.func.isRequired,
  Editurl: PropTypes.string,
  modalName: PropTypes.string,
};

function MasterEdit({ id, name, description, fetchData, handleOk, Editurl }) {
  const [form] = Form.useForm();
  const [initialValues, setInitialValues] = useState({
    name: "",
    description: "",
    initialValues: id,
  });
  // console.log("id in child=====>", id);
  const hasSubmittedRef = useRef(false); // Track if form has been submitted
  const newEndpoint = Editurl === "/centers" ? "centers" : `${Editurl}`;
  const { data } = usePatch(`${newEndpoint}/${id}`);
  const { toastError, toastSuccess } = useToast();

  const handleEdit = async (values) => {
    try {
      const baseData = {
        name: values.name,
        description: values.description,
      };
      // await patchRefetch(baseData);
      await apiClient.patch(`${newEndpoint}/${id}`, baseData);
      fetchData();
      handleOk();
      toastSuccess("Updated Successfully!");
      hasSubmittedRef.current = true; // Mark as submitted
    } catch (err) {
      console.error(err?.response?.data);
      toastError(err?.response?.data?.error || "Update failed");
    }
  };

  useEffect(() => {
    if (id) {
      // Update initial values when ID changes
      setInitialValues({ name, description });
      form.setFieldsValue({ name, description });
    }
  }, [id, name, description, form]);

  useEffect(() => {
    if (hasSubmittedRef.current && data) {
      toastSuccess("Updated Successfully!");
      fetchData(); // Ensure fetchData is called to get the latest data
      handleOk();
      form.resetFields();
      hasSubmittedRef.current = false; // Reset submission status
    }
  }, [data, fetchData, handleOk, form, toastSuccess]);

  return (
    <>
      <Form
        onFinish={handleEdit}
        initialValues={initialValues}
        form={form}
        layout="vertical"
      >
        <FormItem
          name="name"
          label="Name"
          rules={[{ required: true, message: "Name required" }]}
        >
          <Input className="form-control" />
        </FormItem>
        <FormItem
          name="description"
          label="Description"
          rules={[{ required: true, message: "Description required" }]}
        >
          <TextArea
            autoSize={{ minRows: 2, maxRows: 8 }}
            className="form-control"
          />
        </FormItem>
        <div style={{ display: "flex", justifyContent: "center" }}>
          <Button type="primary" htmlType="submit">
            Submit
          </Button>
        </div>
      </Form>
    </>
  );
}

export default MasterEdit;
